import { GroupType } from '@app/core/enums';

export const cdkOverlayClass = 'cdk-global-overlay-position';

export const groupsTypes = [
  { value: GroupType.Public, title: 'messageCenter.groupType_public' },
  { value: GroupType.Private, title: 'messageCenter.groupType_private' }
];

export enum MessageType {
  sms = 0,
  email = 1,
  internal = 2
}

export enum MessageStatus {
  draft = 0,
  created = 1,
  processing = 2,
  sent = 3,
  notSent = 4
}

export enum ChatMessageStatus {
  sent = 'sent',
  delivered = 'delivered',
  viewed = 'viewed'
}

